import { generateCommentCIDKey } from './generateCommentCIDKey';
import { generateItemCIDKey } from '../../Items/utils/generateItemCIDKey';

export const constructCommentThread = (state, cid, path = [], counter) => {
  const currentCommentId =
    path.length === 0 ? cid.commentId : path[path.length - 1];
  const commentCIDKey = generateCommentCIDKey({
    ...cid,
    commentId: currentCommentId,
  });

  const parentCommentId = state.comments.comment.byId[commentCIDKey]?.inReplyTo;

  if (parentCommentId && counter > 0) {
    return constructCommentThread(
      state,
      cid,
      [...path, parentCommentId],
      counter - 1,
    );
  }

  state.comments.commentThread[generateItemCIDKey(cid)] = {
    ...cid,
    commentId: parentCommentId ? currentCommentId : null,
    path,
  };

  return state;
};
